module.exports = __webpack_public_path__ + "static/img/culture.7e1efd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture.png
// module id = F3AV
// module chunks = 1